import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { NotificacaoDestino } from '../_classes/notificacao-destino';
import { Retorno } from '../_classes/retorno';
import { Util } from '../_classes/util';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { NotificacaoService } from '../_servicos/notificacao.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';

@Component({
  selector: 'app-notificacao',
  templateUrl: './notificacao.component.html',
  styleUrls: ['./notificacao.component.scss'],
})
export class NotificacaoComponent implements OnInit {
  private readonly recurso: string = 'notificacao'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = [
    'id',
    'dsAssunto',
    'dtCriacao',
    'dtVisualizacao',
    'dtIgnorado',
    'dtResposta',
    'outros',
  ];

  erros$ = new Subject<boolean>();
  dataSource$: Observable<NotificacaoDestino[]>;
  dataSource: MatTableDataSource<NotificacaoDestino>;
  notificacao: any;

  filtro: string = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Id',
      texto: 'Identificador da notificação',
    },
    {
      titulo: 'Assunto',
      texto: 'Assunto da notificação (geralmente um resumo)',
    },
    {
      titulo: 'Data Criação',
      texto: 'Data da criação da notificação pelo usuário',
    },
    {
      titulo: 'Data Validade',
      texto:
        'Data até quando a notificação será mostrada no caso de não ser respondida ou marcada como ignorada',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private _sN: NotificacaoService,
    private _sR: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private _sEnv: EnvService
  ) {
    this.notificacao = new NotificacaoDestino();
  }

  ngOnInit() {
    this.atualizar();
  }

  executarAoCarregarDatasource(x: NotificacaoDestino[]) {
    this.dataSource = new MatTableDataSource<NotificacaoDestino>(x);
    this.dataSource.filterPredicate = (
      data: NotificacaoDestino,
      filter: string
    ) =>
      data.notificacao.dsAssunto.toLowerCase().includes(filter.toLowerCase());
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;

      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  ver(n: NotificacaoDestino): void {
    this.notificacao = n;
    /*
    const initialState = { class: 'max-content', notificacao: n };
    const bsModalRef: BsModalRef = this.modalService.show(
      NotificacaoMostrarComponent,
      {
        initialState,
      }
    );*/
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this._sEnv.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this._sEnv.servidor.idServidor,
      this._sR
    );

    this._sN
      .listarNotificacoesMinhas(this._sEnv.servidor.nrMatricula)
      .subscribe({
        next: (x: Retorno) => {
          this.executarAoCarregarDatasource(x.resultado);
        },
        error: (e: any) => {
          this.handleError(e.message);
          return EMPTY;
        },
        complete: () => {
          this.carregando = false;
        },
      });
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
